module.exports = __webpack_public_path__ + "img/tick-circle.77dcfdf8.svg";